module.exports = __webpack_public_path__ + "img/u3_miwuzidie.52bf1e7a.jpg";